import ButtonStyled from './ButtonStyled'

const Button = ({
  children = undefined,
  className = undefined,
  onClick = () => {}
}) => {

  return (
    <ButtonStyled
      className={className}
      onClick={onClick}
    >
      {children}
    </ButtonStyled>
  )
}

export default Button
